import React from "react";
import {Formik} from "formik";
import {FormikSelect} from "../form/FormikSelect";
import {FormikTextField} from "../form/FormikTextField";
import {FormActions} from "../metadata/FormActions";
import {useDocumentTranslation} from "../documents/documentContext";
import * as Yup from "yup";
import MenuItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";
import {format} from "../app/dateFormat";
import {RelationTypes} from "./RelationTypes";
import Box from "@mui/material/Box";
import {SquareThumbWithDocTypeOverlay} from "../app/SquareThumbWithDocTypeOverlay";
import {Stack} from "@mui/material";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import PersonIcon from "@mui/icons-material/Person";
import {SearchResultDetailsProvider} from "../search-result-details/SearchResultDetailsContext";

const schema = () => {
    return Yup.object().shape({
        relationTypeId: Yup.string().required("Påkrevd"),
        sourceId: Yup.string(),
    });
};

export const RelatedObjectForm = ({callback, model}) => {
    const t = useDocumentTranslation();
    const relationTypes = RelationTypes().getList();

    const onClose = () => {
        callback(null);
    };

    return (
        <Formik
            initialValues={{
                relationTypeId: model?.relationTypeId || "",
                relationDescription: model?.relationDescription || "",
                uniqueId: model?.uniqueId,
            }}
            onSubmit={(values) => {
                if (!values.baseModel && model.baseModel) {
                    values['baseModel'] = model.baseModel;
                }
                callback(values);
            }}
            validationSchema={schema()}
        >
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    maxWidth: '600px'
                }}
            >
                <Typography variant="h5" gutterBottom={true}>
                    {t("txtEditObjectRelation", "Redigere relasjon")}
                </Typography>

                <Stack direction="row" spacing={2}>
                    {model && <SearchResultDetailsProvider>
                        <SquareThumbWithDocTypeOverlay model={model}/>
                    </SearchResultDetailsProvider>}

                    <Stack direction="column" sx={{
                        justifyContent: "end"
                    }}>
                        <Stack direction="row" spacing={1} sx={{
                            alignItems: "center"
                        }}>
                            <InsertDriveFileIcon color="secondary"/>
                            <Typography variant="body2">{model?.title}</Typography>
                        </Stack>

                        <Stack
                            direction="row"
                            spacing={1}
                            sx={{
                                alignItems: "center",
                                marginTop: '8px'
                            }}>
                            <PersonIcon color="secondary"/>
                            <Typography variant="body2">
                                {format(model?.createdAt, "P")} - {model?.createdByName}
                            </Typography>
                        </Stack>
                    </Stack>
                </Stack>

                <Typography variant="body1" sx={{marginTop: '16px'}}>
                    {t("txtDescribeObjectRelation", "Beskriv relasjon")}
                </Typography>
                <Typography variant="caption" gutterBottom={true}>
                    {t(
                        "txtDescribeObjectRelationHelp",
                        "Hvis nødvendig, beskriv relasjonen ved å fylle ut feltene nedenfor." +
                        'Klikker du "Avbryt", vil relasjonen allikevel opprettes - uten beskrivelse eller type.'
                    )}
                </Typography>
                <Box sx={{marginBottom: '16px', marginTop: '16px'}}>
                    <FormikSelect
                        formikKey={"relationTypeId"}
                        label={t("txtTypeObjectRelation", "Type relasjon")}
                        fullWidth={true}
                    >
                        {relationTypes.map((r) => (
                            <MenuItem key={r.id} value={r.id}>
                                {r.title}
                            </MenuItem>
                        ))}
                    </FormikSelect>
                </Box>
                <Box sx={{marginBottom: '16px'}}>
                    <FormikTextField
                        formikKey={"relationDescription"}
                        label={t("relationDescription", "Relasjonsbeskrivelse")}
                        fullWidth={true}
                    />
                </Box>
                <FormActions onCancel={onClose}/>
            </Box>
        </Formik>
    );
};
